<template>
  <el-form
    ref="loginForm"
    :model="loginForm"
    :rules="loginRules"
    class="login-form"
    auto-complete="on"
    label-position="right"
    label-width="60px"
  >
    <el-form-item prop="mobile" label="手机号">
      <el-input
        ref="mobile"
        v-model="loginForm.mobile"
        placeholder="请输入您的手机号"
        name="mobile"
        type="text"
        tabindex="1"
        auto-complete="on"
      >
        <!-- <el-select v-model="select" slot="prepend">
        <el-option label="+86" value="+86">+86</el-option>
        <el-option label="+85" value="+85">+85</el-option>
      </el-select> -->
      </el-input>
    </el-form-item>

    <el-form-item prop="captcha" label="验证码">
      <el-input
        ref="password"
        v-model="loginForm.captcha"
        placeholder="请输入验证码"
        name="captcha"
        tabindex="2"
        auto-complete="on"
        @keyup.enter.native="handleLogin"
      >
        <el-button
          v-if="count < 1"
          slot="suffix"
          type="text"
          @click="handleGetCode"
          >获取验证码</el-button
        >
        <el-button v-if="count > 0" slot="suffix" type="text" disabled>{{
          count
        }}</el-button>
      </el-input>
    </el-form-item>

    <el-button
      :loading="loading"
      type="primary"
      style="width: 100%; margin-bottom: 30px; margin-top: 20px;"
      @click.native.prevent="handleLogin"
      >登录</el-button
    >
  </el-form>
</template>

<script>
import { validMobile } from "@/utils/validate";
import { getCode } from "@/api/user";
let timer;
export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!validMobile(value)) {
        callback(new Error("手机号无效"));
      } else {
        callback();
      }
    };

    return {
      count: 0,
      select: "+86",
      loginForm: {
        mobile: "",
        captcha: "",
      },
      loginRules: {
        mobile: [
          { required: true, trigger: "blur", validator: validateMobile },
        ],
        captcha: [{ required: true, trigger: "blur", message: "验证码不能为空" }],
      },
      loading: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    handleGetCode() {
      if (!this.loginForm.mobile) return;
      getCode({
          mobile: this.loginForm.mobile
      }).then(() => {
        this.count = 60;
        clearInterval(timer);
        timer = setInterval(() => {
          if (this.count < 1) {
            clearInterval(timer);
          }
          this.count--;
        }, 1000);
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("user/messageLogin", this.loginForm)
            .then(() => {
              this.$router.push({ path: this.redirect || "/" });
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" >
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  display: none;
}
</style>